import React, {useEffect, useState, useRef} from "react";
import kairoslogo from '../assets/images/kairos-logo.png';
import callicon from '../assets/images/call-icon.png';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { apiUrl, assetsUrl } from "../config/Config";
import axios from "axios";
import Swal from 'sweetalert2';
import AOS from "aos";
import 'aos/dist/aos.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Drawer, List, ListItem, ListItemText, Button } from '@mui/material';
import { faPlus, faMinus, faXmark, faBars, faHandshake, faAward, faCircleCheck, faCubes, faClipboardCheck } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const navigate = useNavigate();
   const faqsprevdata = [
    {isshow: true, question: "The expense windows adapted sir. Wrong widen drawn.", answer: "Offending belonging promotion provision an be oh consulted ourselves it. Blessing welcomed ladyship she met humoured sir breeding her. "},
    {isshow: false, question: "Six curiosity day assurance bed necessary?", answer: "Offending belonging promotion provision an be oh consulted ourselves it. Blessing welcomed ladyship she met humoured sir breeding her. "},
    {isshow: false, question: "Produce say the ten moments parties?", answer: "Offending belonging promotion provision an be oh consulted ourselves it. Blessing welcomed ladyship she met humoured sir breeding her. "},
    {isshow: false, question: "Simple innate summer fat appear basket his desire joy?", answer: "Offending belonging promotion provision an be oh consulted ourselves it. Blessing welcomed ladyship she met humoured sir breeding her. "},
   ]
   const [showenquiremodal, setshowenquiremodal] = useState(false);
   const [fullname, setfullname] = useState("");
   const [email, setemail] = useState("");
   const [number, setnumber] = useState("");
   const [message, setmessage] = useState("");
   const [showloading, setshowloding] = useState(false);

   const [faqsdata, setfaqsdata] = useState(faqsprevdata);
   const [forceupdatestate, setforceupdatestate] = useState(false);
   const [activesection, setactivesection] = useState('Home');
   const faqsdataRef = useRef([]);
   faqsdataRef.current = faqsdata;

   const homeRef = useRef(null);
   const aboutRef = useRef(null);
   const serviceRef = useRef(null);
   const faqRef = useRef(null);
   const contactRef = useRef(null);

   const [allservices, setallservices] = useState([]);
   const [selectedservice, setselectedservice] = useState({});
   const selectedserviceRef = useRef();
   selectedserviceRef.current = selectedservice;
   const [showservicemodal, setshowservicemodal] = useState(false);

   const [open, setOpen] = useState(false);

   const toggleDrawer = (state) => {
    setOpen(state);
  };

   const fetallservices = async() => {
      const headers = {
        headers: {
          "Content-Type": "application/json"
        },
      };
      let resp = await axios
        .get(apiUrl + "userallservices", headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            if(res.data?.data?.length > 0) {
              setallservices(res.data?.data)
            } else {
              setallservices([])
            }
            
            setshowloding(false);
          } else {
            
            setshowloding(false);
          }
        })
        .catch((err) => {
          setshowloding(false);
          alert(err.message);
        });
   }

   const submithandle = async() => {
    if(fullname && email && number) {
      var data = {
        fullname: fullname,
        email: email,
        number: number,
        message: message
      }
      const headers = {
        headers: {
          "Content-Type": "application/json"
        },
      };
      let resp = await axios
        .post(apiUrl + "createenquire", data, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            Swal.fire({
              title: '',
              text: "Enquired Successfully",
              icon: 'success',
              customClass: {
                icon: 'custom-swal-icon' // Apply the custom class
              },
              width: '350px',
              confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
              customClass: {
                  popup: "small-icon-alert",
                },
            });
            setshowenquiremodal(false);
            setfullname("");
            setemail("");
            setnumber("");
            setmessage("");
            setshowloding(false);
          } else {
            
            setshowloding(false);
          }
        })
        .catch((err) => {
          setshowloding(false);
          alert(err.message);
        });
      setshowloding(false);
    } else {
      alert('Enter all required fields');
    }
   }

   const handlefaqtoggle = (index, currentstatus) => {
    var prevdata = faqsdataRef.current;
    var newdata = [];
    for(var i = 0; i < prevdata?.length; i++) {
      if(i == index) {
        var obj = prevdata[i];
        obj.isshow = !currentstatus;
        newdata.push(prevdata[i]);
      } else {
        var obj = prevdata[i];
        obj.isshow = false;
        newdata.push(prevdata[i]);
      }
    }
    setfaqsdata(newdata);
    setforceupdatestate(!forceupdatestate);
   }

   const [sticky, setSticky] = useState("");
     const isSticky = () => {
       /* Method that will fix header after a specific scrollable */
       const scrollTop = window.scrollY;
       const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
       setSticky(stickyClass);
       console.log(stickyClass);
     };
     const classes = `main-header-div ${sticky} mobhide`;

     const scrollToHome = () => {
      if (homeRef.current) {
        const topOffset = homeRef.current.offsetTop; // adjust 80 for your header
        window.scrollTo({ top: topOffset, behavior: 'smooth' });
        setactivesection('Home');
        setOpen(false);
      }
    };

    const scrollToAbout = () => {
      const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
      console.log('isHeaderFixed >>', isHeaderFixed);
  const offset = isHeaderFixed ? 70 : window.innerWidth <= 1024 ? 60 : 190;

  const y = aboutRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
  setactivesection('Profile');
  setOpen(false);
    };

    const scrollToService = () => {
      const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
      console.log('isHeaderFixed >>', isHeaderFixed);
  const offset = isHeaderFixed ? 70 :  window.innerWidth <= 1024 ? 60 : 190;

  const y = serviceRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
  setactivesection('Services');
  setOpen(false);
    };

    const scrollToFaq = () => {
      const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
      console.log('isHeaderFixed >>', isHeaderFixed);
  const offset = isHeaderFixed ? 70 : window.innerWidth <= 1024 ? 60 : 190;

  const y = faqRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
  setactivesection('FAQs');
  setOpen(false);
    };

    const scrollToContact = () => {
      const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
      console.log('isHeaderFixed >>', isHeaderFixed);
  const offset = isHeaderFixed ? 70 : window.innerWidth <= 1024 ? 60 : 190;

  const y = contactRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
  setactivesection('Contact');
  setOpen(false);
    };

    const handleserviceclick = (obj) => {
      console.log('obj >>', obj);
      setselectedservice(obj);
      setTimeout(() => {
        setshowservicemodal(true);
      }, 1000)
    }

    const handleshowenqmodal = () => {
      setfullname("");
            setemail("");
            setnumber("");
            setmessage("");
      setshowenquiremodal(true);
    }

    const handleclickproductbox = (item) => {
      console.log('item >>', item)
      window.open('/products/'+item?.title+'/'+item?.id, '_blank');
    }
    
   
     useEffect(() => {
       // fetchcourses();
       const handleScroll = () => {
        if(window.innerWidth <= 1024) {
          return 
        }
        const scrollY = window.scrollY + 100; // Add padding to detect a bit earlier
    
        const sections = [
          { id: "Home", ref: homeRef },
          { id: "Profile", ref: aboutRef },
          { id: "Services", ref: serviceRef },
          { id: "FAQs", ref: faqRef },
          { id: "Contact", ref: contactRef },
        ];
    
        for (let section of sections) {
          const offsetTop = section.ref.current.offsetTop;
          const offsetHeight = section.ref.current.offsetHeight;
    
          if (scrollY >= offsetTop && scrollY < offsetTop + offsetHeight) {
            setactivesection(section.id);
            break;
          }
        }

        // sticky header

        const scrollTop = window.scrollY;
       const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
       setSticky(stickyClass);
       console.log(stickyClass);
      };

       window.addEventListener("scroll", handleScroll);
       return () => {
         window.removeEventListener("scroll", handleScroll);
       };

     }, []);

     useEffect(() => {
      fetallservices();
      AOS.init();
      AOS.refresh();
     }, [])
    return (
      <>
      <div className={classes} ref={homeRef}>
        <div className="container">
          <div className="header-row">
            <div className="header-logo-div">
              <img src={kairoslogo} className="kairoslogo" />
            </div>
            <div className="header-navbar">
              <nav className="navbar navbar-expand-lg  custom-nav ">
                <ul class="navbar-nav">
                  <li className={activesection == "Home" ? "nav-item active" : "nav-item"}>
                    <Link onClick={scrollToHome}>Home</Link>
                  </li>
                  <li className={activesection == "Profile" ? "nav-item active" : "nav-item"}>
                    <Link onClick={scrollToAbout}>Profile</Link>
                  </li>
                  <li className={activesection == "Services" ? "nav-item active" : "nav-item"}>
                    <Link onClick={scrollToService}>Products Range</Link>
                  </li>
                  <li className={activesection == "FAQs" ? "nav-item active" : "nav-item"}>
                    <Link onClick={scrollToFaq}>FAQs</Link>
                  </li>
                  <li className={activesection == "Contact" ? "nav-item active" : "nav-item"}>
                    <Link onClick={scrollToContact}>Contact</Link>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="header-number-div">
                <img src={callicon} className="calliconimg" />
                <Link to={'tel: +919819323245'} className="callicontext">+91 9819323245</Link>
            </div>
          </div>
        </div>
      </div>
      <div className="deskhide">
          <div className="mobilemaindiv">
            <div
              className="mobilemenudiv"
              onClick={() => {
                setOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faBars} className="menubaricon" />
            </div>
            <img src={kairoslogo} alt="Logo" className="website-logo" />
          </div>
          <div className="navbarheight" />

        <Drawer
            anchor="left"
            open={open}
            onClose={() => {
              toggleDrawer(false);
            }}
          >
            <List sx={{ width: 250 }}>
              <div className="mobilemenusidebarmaindiv">
                <div
                  className="mobilemenusidebar-closediv"
                  onClick={() => {
                    toggleDrawer(false);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="menubariconsidebar"
                  />
                </div>
                <nav className="navbar navbar-expand-lg  custom-nav ">
                <ul class="navbar-nav">
                  <li className={activesection == "Home" ? "nav-item active" : "nav-item"}>
                    <Link onClick={scrollToHome}>Home</Link>
                  </li>
                  <li className={activesection == "Profile" ? "nav-item active" : "nav-item"}>
                    <Link onClick={scrollToAbout}>Profile</Link>
                  </li>
                  <li className={activesection == "Services" ? "nav-item active" : "nav-item"}>
                    <Link onClick={scrollToService}>Products Range</Link>
                  </li>
                  <li className={activesection == "FAQs" ? "nav-item active" : "nav-item"}>
                    <Link onClick={scrollToFaq}>FAQs</Link>
                  </li>
                  <li className={activesection == "Contact" ? "nav-item active" : "nav-item"}>
                    <Link onClick={scrollToContact}>Contact</Link>
                  </li>
                </ul>
                </nav>
                
              </div>
              {/* {['Dashboard', 'Profile', 'Settings', 'Logout'].map((text) => (
            <ListItem button key={text}>
              <ListItemText primary={text} />
            </ListItem>
          ))} */}
            </List>
          </Drawer>

          </div>
      </>
    );
}

export default Header